import { IconProps } from '../icon';

export function CadenasIcon(props: IconProps) {
  return (
    <svg
      id="Cadenas"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="30.771"
      height="40"
      viewBox="0 0 30.771 40"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_2429"
            data-name="Rectangle 2429"
            width="30.771"
            height="40"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_2427"
            data-name="Rectangle 2427"
            width="24.612"
            height="19.994"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_11688" data-name="Groupe 11688" clipPath="url(#clipPath)">
        <g id="Groupe_11687" data-name="Groupe 11687">
          <g
            id="Groupe_11686"
            data-name="Groupe 11686"
            clipPath="url(#clipPath)"
          >
            <path
              id="Tracé_9447"
              data-name="Tracé 9447"
              d="M15.313,40c-3.49,0-6.98.007-10.47,0A4.572,4.572,0,0,1,.006,35.187q-.012-8.26,0-16.52A4.536,4.536,0,0,1,3.881,13.92c.643-.113.759-.338.745-.9a14.831,14.831,0,0,1,.892-6.591,10.983,10.983,0,0,1,7.9-6.249A10.724,10.724,0,0,1,25.375,6.788c.824,2.059.736,4.1.765,6.275.007.526.091.749.7.842a4.54,4.54,0,0,1,3.919,4.617q.019,8.4,0,16.808a4.551,4.551,0,0,1-4.689,4.662c-3.586.016-7.172,0-10.758,0m.048-3.076q5.14,0,10.279,0c1.461,0,2.046-.578,2.047-2.023q.006-7.973,0-15.946c0-1.446-.585-2.02-2.048-2.021q-10.232,0-20.463,0c-1.528,0-2.094.56-2.095,2.071q0,7.925,0,15.85c0,1.51.568,2.068,2.1,2.07q5.092,0,10.183,0m0-23.069c2.3,0,4.608-.02,6.911.013.62.009.855-.162.812-.8a20.612,20.612,0,0,0-.283-4.3,7.78,7.78,0,0,0-2.211-3.646A7.688,7.688,0,0,0,9,6.521C7.634,8.53,7.738,10.79,7.681,13.116c-.015.609.2.753.771.747,2.3-.028,4.607-.012,6.911-.012"
              transform="translate(0 0)"
              fill="#41B883"
            />
            <g
              id="Groupe_11685"
              data-name="Groupe 11685"
              transform="translate(3.079 16.926)"
              opacity="0.5"
            >
              <g id="Groupe_11684" data-name="Groupe 11684">
                <g
                  id="Groupe_11683"
                  data-name="Groupe 11683"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_9448"
                    data-name="Tracé 9448"
                    d="M28.287,107.988q-5.092,0-10.183,0c-1.528,0-2.1-.56-2.1-2.07q0-7.925,0-15.85c0-1.511.568-2.07,2.1-2.071q10.232,0,20.463,0c1.463,0,2.047.575,2.048,2.021q.007,7.973,0,15.946c0,1.445-.586,2.021-2.047,2.023q-5.14.007-10.28,0m.041-16.917A4.578,4.578,0,0,0,24.035,93.9a4.037,4.037,0,0,0,1.159,5.019c1.6,1.066,1.733,2.35,1.58,3.93a3.219,3.219,0,0,0,0,.48,1.516,1.516,0,0,0,1.567,1.576,1.494,1.494,0,0,0,1.5-1.541,19.09,19.09,0,0,0-.005-2.206,1.452,1.452,0,0,1,.843-1.586,4.405,4.405,0,0,0,2.043-5.28,4.6,4.6,0,0,0-4.4-3.225"
                    transform="translate(-16.005 -87.994)"
                    fill="#41B883"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_9449"
              data-name="Tracé 9449"
              d="M60.4,103.989a4.6,4.6,0,0,1,4.4,3.225,4.406,4.406,0,0,1-2.043,5.28c-1.174.676-.827,2.013-.811,3.174a3.059,3.059,0,0,1-.154,1.24,1.515,1.515,0,0,1-2.865-.292c-.235-.916.094-1.865-.148-2.793a3.448,3.448,0,0,0-1.507-1.981,4.037,4.037,0,0,1-1.159-5.019,4.578,4.578,0,0,1,4.292-2.833m1.516,4.6a1.533,1.533,0,1,0-1.493,1.55,1.549,1.549,0,0,0,1.493-1.55"
              transform="translate(-44.997 -83.986)"
              fill="#41B883"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CadenasIcon;
